import React, { useEffect, useState } from 'react'
import { Card, Flex, Pagination, Button, Image } from 'antd'
import { getAIToolsListAPI } from '@/apis/common'
import { useLocation, useNavigate } from 'react-router-dom'
import { checkMenu, checkLogin } from '@/utils'

export default function AiToolsList() {
  const location = useLocation()
  const navigate = useNavigate()

  //  列表请求参数
  const [listQuery, setListQuery] = useState({
    pageInt: 1,
    pageSize: 10,
  })
  const [total, setTotal] = useState(0) //  列表总数
  const [list, setList] = useState([])

  //  获取楼盘户型列表
  const fetchData = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    const res = await getAIToolsListAPI(listQuery)
    console.log(res)
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.key = index + 1
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
    } else {
      setList([])
      setTotal(0)
    }
  }
  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    setTotal(0)
    fetchData()
  }

  useEffect(() => {
    if(!checkMenu(location.pathname)) {
      navigate('/managecenter/404')
      return
    }
    fetchData()
  }, [])
  return (
    <div>
      <div className="pageTitle">武房AI工具集</div>
      <Card className="card">
        <Flex wrap gap="large">
          {list.map((item, index) => {
            return (
              <div className="bg-fafafa border-radius-2 padding-left-24 padding-right-24 padding-top-32 padding-bottom-32" style={{ width: '352px', height: '328px',  }} key={index}>
                <div className="flex align-items line-height-32">
                  <Image src={item.iconUrl} style={{ width: '32px', height: '32px' }} />
                  <div className="margin-left-12 font-weight-500 font-size24">{item.name}</div>
                </div>
                <div className="margin-top-24 line-height-24 font-size16 ellipsis-6" style={{height: '148px'}}>{item.description}</div>
                <Button type="primary" className="bg-green margin-top-24 font-size14 border-radius-2" href={item.linkUrl} target="_blank">立即体验</Button>
              </div>
            )
          })}
        </Flex>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
      </Card>
    </div>
    
  )
}
